import { render, staticRenderFns } from "./RecordScreen.vue?vue&type=template&id=47a31835&scoped=true&"
import script from "./RecordScreen.vue?vue&type=script&lang=js&"
export * from "./RecordScreen.vue?vue&type=script&lang=js&"
import style0 from "./RecordScreen.vue?vue&type=style&index=0&id=47a31835&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a31835",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
